// extracted by mini-css-extract-plugin
export default {"About":"About_About__1+nIm","content":"About_content__lMehE"};